export default __webpack_public_path__ + "static/P_SearchThumb_IN-Wx-27230e55aacd7722e07bf91eb49fbd23.webp";